import {FC} from "react";
import {makeStyles} from "tss-react/mui";
import {Box} from "@mui/material";
import {Route, Routes} from "react-router-dom";
import {AdminPlaylistList} from "./AdminPlaylistList";
import {AdminPlaylistPage} from "./AdminPlaylistPage/AdminPlaylistPage";
import {AdminPlaylistLandingPage} from "./AdminPlaylistLandingPage/AdminPlaylistLandingPage";

const useStyles = makeStyles()((theme) => ({
	adminLessonsPage: {

	}
}));

export const AdminPlaylistsPage: FC = () => {
	const {classes} = useStyles();

	return (
		<Box className={classes.adminLessonsPage}>
			<Routes>
				<Route index element={<AdminPlaylistList />}/>
				<Route path="create" element={<AdminPlaylistPage />} />
				<Route path=":playlistId/*" element={<AdminPlaylistLandingPage />} />
				<Route path=":playlistId/edit" element={<AdminPlaylistPage />} />
			</Routes>
		</Box>
	);
}